module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-16.14093ce9.jpg";